module.exports = "/public/images/d933bd86db616d57b83559c5491dfa6f.png";